import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EcomItemOptionTypesDto } from '../shared/dto/ecom-item-options-type.dto';
import { EcomItemDto } from '../shared/dto/ecom-item.dto';
import { EcomOptionsTypeSerachDto } from '../shared/dto/ecom-options-type-search.dto';
import { EcomOptionsTypeService } from '../shared/ecom-options-type.service';

@Component({
  selector: 'wl-ecom-item-edit-option-types',
  templateUrl: './ecom-item-edit-option-types.component.html',
  styleUrls: ['./ecom-item-edit-option-types.component.less'],
    standalone: false
})
export class EcomItemEditOptionTypesComponent implements OnChanges {
  @Input() eCommerceItem: EcomItemDto;

  constructor(private _ecomOptionTypeService: EcomOptionsTypeService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eCommerceItem != null) {
      this._ecomOptionTypeService.search({ PageNumber: 0, PageSize: 0 } as EcomOptionsTypeSerachDto).then((data) => {
        // map the item types to empty ItemOptionTypes
        let maxSort = 0;
        if (this.eCommerceItem?.ItemOptionTypes?.length) {
          maxSort = this.eCommerceItem.ItemOptionTypes.reduce((x, y) => (x.SortOrder > y.SortOrder ? x : y)).SortOrder ?? 0;
        }
        let x = data.Result.filter((x) => !this.eCommerceItem.ItemOptionTypes.some((ot) => ot.OptionTypeId == x.OptionTypeId)).map((x) => {
          return { Title: x.Descr, SortOrder: ++maxSort, OptionTypeId: x.OptionTypeId } as EcomItemOptionTypesDto;
        });
        this.eCommerceItem.ItemOptionTypes.push(...x);
      });
    }
  }
}
